import Carousel, { CarouselProps, DotPositionType, EffectType } from './carousel'
import { Slidebar } from './slidebar'
import { SlideList } from './slideList'
import { FadeList } from './fadeList'
export * from './carousel'
export { CarouselProps, DotPositionType, EffectType, Slidebar, FadeList, SlideList }
export default Carousel
